// extracted by mini-css-extract-plugin
export default {"welcomeContainer":"WelcomeMessage_welcomeContainer__uSToK","line":"WelcomeMessage_line__A7Zlq","title":"WelcomeMessage_title__JF5bI"};